{
  "CANNED_MGMT": {
    "HEADER": "Tallennetut vastaukset",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Tätä hakua vastaavia kohteita ei löydy.",
    "LIST": {
      "404": "Tällä tilillä ei ole tallennettuja vastauksia.",
      "TITLE": "Hallitse tallennettuja vastauksia",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Sisältö",
        "INBOXES": "Saapuneet-kansiot",
        "ACTIONS": "Toiminnot"
      },
      "ALL_INBOXES": "Kaikki saapuneet-kansiot",
      "FILTER": {
        "ALL_INBOXES": "Kaikki saapuneet-kansiot",
        "NO_INBOX": "Ei saapuneet-kansiota",
        "SEARCH_PLACEHOLDER": "Hae saapuneet-kansioita"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Aihe (vain sähköposti)",
          "PLACEHOLDER": "Valinnainen aihe sähköpostivastauksille / uusille keskusteluille"
        },
        "CONTENT": {
          "LABEL": "Viesti",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Liitteet"
        },
        "INBOXES": {
          "LABEL": "Saapuneet-kansiot",
          "PLACEHOLDER": "Valitse saapuneet-kansiot (valinnainen, jätä tyhjäksi kaikkia saapuneet-kansioita varten)"
        },
        "SUBMIT": "Lähetä"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Aihe (vain sähköposti)",
          "PLACEHOLDER": "Valinnainen aihe sähköpostivastauksille / uusille keskusteluille"
        },
        "CONTENT": {
          "LABEL": "Viesti",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Liitteet"
        },
        "INBOXES": {
          "LABEL": "Saapuneet-kansiot",
          "PLACEHOLDER": "Valitse saapuneet-kansiot (valinnainen, jätä tyhjäksi kaikkia saapuneet-kansioita varten)"
        },
        "SUBMIT": "Lähetä"
      },
      "BUTTON_TEXT": "Muokkaa",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Poista",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      },
      "CONFIRM": {
        "TITLE": "Confirm deletion",
        "MESSAGE": "Oletko varma että haluat poistaa ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
